// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig, fetchAndActivate, getValue } from "firebase/remote-config";
// TODO: Replace with your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC1r_vSkkxoLAZNyelgKOsLFafbcCkjlW0",
  authDomain: "mynaksh-prod-website.firebaseapp.com",
  projectId: "mynaksh-prod-website",
  storageBucket: "mynaksh-prod-website.firebasestorage.app",
  messagingSenderId: "832405137292",
  appId: "1:832405137292:web:3625b4f5b6b745133c98a9"
};

// staging config
// const firebaseConfig = {
//   apiKey: "AIzaSyDjtuim3zxZWMxdfFl6aLQc2ZfL7vMWRUE",
//   authDomain: "mynaksh-website.firebaseapp.com",
//   projectId: "mynaksh-website",
//   storageBucket: "mynaksh-website.firebasestorage.app",
//   messagingSenderId: "314311228997",
//   appId: "1:314311228997:web:81bee800df157ddb9a6d2c"
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);
const remoteConfig = getRemoteConfig(app);

remoteConfig.settings.minimumFetchIntervalMillis = 0; // For debugging, set to 0 to force fetch
remoteConfig.defaultConfig = {
  tnc: "Default Terms and Conditions content.",
  privacyPolicy: "Default Privacy Policy content.",
};

async function fetchRemoteConfig() {
  try {
    await fetchAndActivate(remoteConfig);
    console.log("Remote Config fetched and activated.");
    console.log("Remote Config tnc:", getValue(remoteConfig, 'tnc').asString());
    console.log("Remote Config privacyPolicy:", getValue(remoteConfig, 'privacyPolicy').asString());
  } catch (err) {
    console.error("Error fetching remote config:", err);
  }
}

export { db, analytics, collection, addDoc, remoteConfig, fetchRemoteConfig, getValue };